module.exports = __webpack_public_path__ + "img/google-play.52994d62.png";